export const roundThePrice = (x,roundValue,digit) =>{
    if(roundValue==null){
        //Si aucune configuration d'arrondi, on retourne le montant non arrondi
        let valeur = Number(String(x).replace(',', '.'));
        return valeur.toFixed(digit);
    }else{
        //Sinon on l'arrondi sur la valeur enregistré sur la configuration company 
        let roundit=Math.round(x / +roundValue) * +roundValue;
        return roundit.toFixed(digit);
    }
}